import component from './property-market.js';

component.name += 'New';

export default component;
